import { render, staticRenderFns } from "./NoPlasticMeasure.vue?vue&type=template&id=f0460b32&"
import script from "./NoPlasticMeasure.vue?vue&type=script&lang=js&"
export * from "./NoPlasticMeasure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports